// @packages
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

// @scripts
import CtrlTextField from '../ctrl-text-field';
import { config } from '../../../../config';
import { globalUI } from '../../../../core';
import { isAllPropsValid } from '../../../../helpers';

// @styles
import styles from './styles';
import { VerticalAlignCenter } from '@material-ui/icons';

const CtrlEditCandidateItem = ({
    className,
    classes,
    fields,
    id,
    item,
    onBlur,
    visible
}) => {
    // if (!visible) {
    //     return null;
    // }

    const initialState = {};
    fields.forEach((field) => {
        initialState[field.name] = {
            isValid: true,
            value: field.defaultValue
        };
    });

    useEffect(() => {
        fields.forEach((field) => {
            item[field.name] = field.defaultValue;
        });
    }, []);

    const [state, setState] = useState(initialState);
    const handleOnFieldChange = ({ name, isValid, value }) => {
        const newState = {
            ...state,
            [name]: {
                isValid,
                value
            }
        };
        setState(newState);
        item[name] = value;
        globalUI.formModalDialogValid(isAllPropsValid(newState));
    };

    const handleOnFieldBlur = () => {
        if (onBlur) {
            onBlur();
        }
    };

    const editCandidateItemClass = classNames(
        className,
        classes.editCandidateItem
    );

    return (
        <div>
            <div
                id={`${id}-edit-candidate-item`}
                className={editCandidateItemClass}
            >
                {fields.map((fieldProps, index) => (
                    <CtrlTextField
                        id={`${id}-${fieldProps.name}`}
                        key={index}
                        label={config.text.schedulePage.headerLabels[fieldProps.name] || fieldProps.name}
                        onBlur={handleOnFieldBlur}
                        onChange={handleOnFieldChange}
                        showErrors
                        value={state[fieldProps.name].value}
                        {...fieldProps}
                    />
                ))}
            </div>
            {
                item.louversInputs.wpFactor == 1 && item.waterPenSafFac >= 1 && item.waterPenSafFac < 1.15 && (
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-2 align-self-center text-center">
                                <i class='fas fa-exclamation-triangle fa-2x status-icon' style={{ color: '#EDDB1E' }}>
                                </i>
                            </div>
                            <div className="col-sm-10" style={{ fontSize: '11px' }}>
                                <label>Airflow volume is greater than recommended for the size selected. Please consider increasing the louver size or decreasing the airflow volume. The recommended Water Pen Safety Factor is 1.15 or higher.</label>
                            </div>
                        </div>
                    </div>
                )
            }
        </div>
    );
};

CtrlEditCandidateItem.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired,
    fields: PropTypes.array.isRequired,
    id: PropTypes.string.isRequired,
    item: PropTypes.object.isRequired,
    onBlur: PropTypes.func,
    visible: PropTypes.bool
};

CtrlEditCandidateItem.defaultProps = {
    className: null,
    onBlur: null,
    visible: true
};

export default withStyles(styles)(CtrlEditCandidateItem);
